import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { AppBar, Hidden } from '@material-ui/core';
import classNames from 'classnames';
import { isMobileOnly, isTablet } from 'react-device-detect';
import _ from 'lodash';

import './Page.scss';
import AppContext from '../../App.context';
import AppModeContext from '../AppMode/AppMode.context';
import ContentState from '../../interfaces/ContentState';
import Header from '../../components/Header/Header';
import BottomMenu from '../../components/BottomMenu/BottomMenu';
import Footer from '../../components/Footer/Footer';
import SideBar from '../../components/SideBar/SideBar';
import MarketsGrid from '../../components/MarketsGrid/MarketsGrid';
import HorseBetting from '../../components/HorseBetting/HorseBetting';
import { default as Banner } from 'src/components/Banner/BannerContainer/BannerContainer';
import ContentBlock from 'src/components/ContentBlock/ContentBlock';
import ContentCluster from 'src/components/ContentCluster/ContentCluster';
import ContentTickertape from 'src/components/ContentTickertape/ContentTickertape';

const COMPONENTS = { MarketsGrid, HorseBetting, Banner, ContentBlock, ContentCluster, ContentTickertape };

interface PageProps {
  template?: ContentState['template'],
  childComponent?: string
}

interface PageState {
  leftSideBarCollapsed?: boolean,
  rightSideBarCollapsed?: boolean
}

class Page extends PureComponent<PageProps, PageState> {

  private pageMainRef: HTMLDivElement;

  constructor(props: PageProps) {
    super(props);
  }

  defineSideBar = (type) => {
    if (type === 'bottomSideBar') {
      return (
        <AppBar position="fixed" className="page--bottom">
          <SideBar sideBar={ type } />
        </AppBar>
      );
    }

    return this.props.template[type].show && (
      <div className={
        classNames({
          'page--left': type === 'leftSideBar',
          'page--collapsed': this.props.template.leftSideBar.collapsed || this.props.template.rightSideBar.collapsed,
          'page--right': type === 'rightSideBar'
        })
      }
      >
        <SideBar sideBar={ type } />
      </div>
    );
  }

  renderSidebar = (size, sidebar, isPortrait) => {
    const props = { [size]: (isMobileOnly || (isTablet && isPortrait)) ? true : false };

    return (
      <Hidden { ...props }>
        { this.defineSideBar(sidebar) }
      </Hidden>
    );
  }

  renderPage = () => {
    const { childComponent, children, template } = this.props;
    const ChildComponent = COMPONENTS[childComponent];
    const renderComponents = () => {
      if (template.main.components?.length === 0) return children;

      return _.map(template.main.components, c => {
        if (c.type === 'Events') return children;

        const Component = COMPONENTS[c.type];

        return <Component data={ c } key={ c.type } />;
      });
    };

    return (
      <div className="page--middle">
        <>
          <div
            className="page__component-wrapper"
            style={
              { minHeight: this.pageMainRef && this.pageMainRef.getBoundingClientRect().y < 0 ?
                window.innerHeight + this.pageMainRef.getBoundingClientRect().y :
                window.innerHeight }
            }
          >
            { ChildComponent ? <ChildComponent /> : renderComponents() }
          </div>

          { template.footer.show && <Footer /> }
        </>
      </div>
    );
  }

  render() {
    return (
      <div className="page">
        <AppContext.Consumer>
          {
            ({ isPortrait }) => (
              <>
                <AppModeContext.Consumer>
                  {
                    ({ RETAIL_MODE, TRADING_MODE }) => {
                      return (<>

                        { this.props.template.header.show && <Header /> }

                        <div
                          className={
                            classNames('page__main', { 'page__main--retail': (RETAIL_MODE || TRADING_MODE) })
                          }
                          ref={
                            el => this.pageMainRef = el
                          }
                        >
                          { this.renderSidebar('mdDown', 'leftSideBar', isPortrait) }
                          { this.renderPage() }
                          { this.renderSidebar('mdDown', 'rightSideBar', isPortrait) }
                        </div>

                        {
                          (isMobileOnly || (isTablet && isPortrait)) && (
                            <BottomMenu />
                          )
                        }
                      </>
                      );
                    }
                  }

                </AppModeContext.Consumer>

              </>
            )
          }
        </AppContext.Consumer>
      </div>
    );
  }

}

const mapState = state => ({
  template: state.content.template
});

export default connect(mapState, null)(Page);
